<template>
<div>
	<vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="invoiceName"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <Printer :order="selectedOrder" :docType="pdfDocType" v-if="selectedOrder !== null" />
      </section>
    </vue-html2pdf>
    

    <nav-bar-home></nav-bar-home>
	<main id="main" class="account dashboard">
		
		<section class="account-content parten-bg">
			<div class="container-fluid">
			
				<div class="row acc-dashboard">
					
					<section class="account-main col-md-12 col-xs-12">
						<div class="row">
							
							<div class="col-12">
								<dashboard-stats></dashboard-stats>
							</div>
							
						</div>
							
						<h3 class="acc-title lg">My Invoices</h3>
						<div class="search-btns">
							<div class="row">
								<div class="col-lg-7">
									<button class="btn ml-2" :class="{'btn-primary': selected == 'All', 'btn-secondary': selected !== 'All'}" @click="selected = 'All'">All</button>
									<button class="btn ml-2" :class="{'btn-primary': selected == 'Unpaid', 'btn-secondary': selected !== 'Unpaid'}" @click="selected = 'Unpaid'">Unpaid</button>
									<button class="btn ml-2" :class="{'btn-primary': selected == 'Paid', 'btn-secondary': selected !== 'Paid'}" @click="selected = 'Paid'">Paid Credit</button>
								</div>
								<div class="col-lg-5">
									<input type="text" v-model="searchQuery" placeholder="Search..." class="form-control search-input">
								</div>
							</div>
						</div>
						<div class="row db-content">
							<table class="invoice-table table">
								<thead>
									<tr>
										<th>Invoice No</th>
										<th>Invoice Date</th>
										<th>Order No</th>
										<th>Invoice Total</th>
										<th>Product</th>
										<th>Payment Status</th>
										<!-- <th>Payment Status Timeline</th> -->
										<th>Quantity</th>
										<th>Invoice</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="job in paginatedOrders" :key="job._id">
										<td>{{ job.invoiceNumber }}</td>									
										<td >{{ formatDate(job.createdAt) }}</td>	
										<td>{{ job.orderNumber }}</td>
										<td>
											<div v-for="item in job.items" :key="item._id">
												&euro; {{ getTotalPrice(Number(item.quantity.sellingProductPrice), item.vat, item.discountPCPAm, item.discountPromoCodeAm, item.spendDiscountAm).toFixed(2) }}
											</div>
										</td>
										<td style="max-width: 400px; min-width: 250px;">
											<div style="width: 100%;" v-for="item in job.items" :key="item._id">
												<span v-if="isExpanded(item._id)">
													<div style="max-height: 150px; overflow-y: auto; overflow-x: hidden; padding-right: 5px; word-wrap: break-word; white-space: normal;">
														<span v-html="getItemDescription(item).replace(/\n/g, '<br>')"></span>
													</div>
													<a href="#" v-if="isLongDescription(item)"
														@click.prevent="toggleDescription(item._id)"
														style="display: inline-block; margin-top: 5px; color: blue; text-decoration: underline;">See less</a>
												</span>
												<span v-else>
													<div style="word-wrap: break-word; white-space: normal;">
														<span v-html="getShortDescription(item).replace(/\n/g, '<br>')"></span>
													</div>
													<a href="#" v-if="isLongDescription(item)"
														@click.prevent="toggleDescription(item._id)"
														style="display: inline-block; margin-top: 5px; color: blue; text-decoration: underline;">See more</a>
												</span>
											</div>
										</td>
										<td>
											<span v-if="job.paymentStatus">
												<!-- {{ job.paymentStatus }} -->
												<!-- Awaiting Payment condition -->
												<template v-if="job.paymentStatus === 'Awaiting Payment'">
													<span style="color:#566cd7;">{{ job.paymentStatus }}</span>
													<span style="color:#444444;"> {{ 	job.paymentStatusDes ? '(' + job.paymentStatusDes + ')' : '' }}</span>
												</template>
												<!-- Brackets condition -->
												<template v-else-if="job.paymentStatus.includes('(')">
													<span style="color:#566cd7;">
														{{ job.paymentStatus.split('(')[0].trim() }}
													</span>
													<span style="color:#444444;">
														{{'(' + job.paymentStatus.split('(')[1] }}
													</span>
												</template>
												<!-- Default -->
												<template v-else>
													<span style="color:#566cd7;">{{ job.paymentStatus }}</span>
												</template>
											</span>
										</td>
										<!-- <td v-if="job.paymentStatus == 'Awaiting Payment'">{{ getPaymentMessage(job.createdAt, job.user ? job.user.accountTerms : '') }}</td>
											<td v-else> {{ job.paymentStatusDes ? job.paymentStatusDes : '' }}</td> -->
										<td>
											<div v-for="item in job.items" :key="item._id">
											{{ (item.quantity.quantity) }}
											</div>
										</td>
										<!-- <td><img @click="customergeneratePdf(job)" src="@/assets/pdf.png" style="max-width:22px;"></td> -->
										<td>
											<span v-if="job.status == 'Order Completed and Shipped' || orderHadInvoice(job)" title="Download Invoice">
												<img @click="customergeneratePdf(job, 'invoice')" src="@/assets/pdf.png" style="max-width:22px;">
											</span>
											<span v-if="job.status === 'Order Cancelled' && orderHadInvoice(job)" title="Download Credit Invoice" style="margin-left:6px;">
												<img @click="customergeneratePdf(job, 'credit')" src="@/assets/pdf.png" style="max-width:22px;filter: hue-rotate(320deg) saturate(2);">
											</span>
											<button v-if="job.paymentMethod ==='Credit' && job.paymentStatus ==='Awaiting Payment'" @click="payNow(job)" type="button" class="btn btn-success paynow-btn">Pay Now</button>
										</td>

									</tr>
								</tbody>
							</table>
								<div class="pagination-controls">
								<button class="btn btn-primary" @click="prevPage" :disabled="currentPage === 1">Previous</button>
								<span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
								<button class="btn btn-primary" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
							</div>
							<!-- <pre>{{ usOrders }}</pre> -->
							<!-- <pre>{{ usOrders[0].paymentMethod }}</pre> -->
						</div>
					</section><!-- Cart main content : End -->
				</div>
				
			</div>
		</section>
	</main><!-- Main Category: End -->
	<!--Footer : Begin-->
	<div >
		<footer-section></footer-section>	
	</div>

	
</div>
</template>

<script>
// import VueHtml2pdf from 'vue-html2pdf'
// import VueHtml2pdf from 'vue-html2pdf'
// import html2pdf from "html2pdf.js";

import VueHtml2pdf from "vue-html2pdf";
import Printer from './Printer.vue';
import moment from 'moment';
import jsPDF from 'jspdf'
import NavBarHome from "@/components/NavBarHome.vue"
import DashboardStats from "./DashboardStats.vue"
import FooterSection from "@/components/FooterSection.vue"
import {mapState} from 'vuex'
import { loadStripe } from '@stripe/stripe-js';

export default {
components:{
	DashboardStats,
	NavBarHome,
	FooterSection,
	Printer,
	VueHtml2pdf,
},
data(){
	return {
	selected: 'All',
      selectedOrder: null,
	  invoiceName: "",
	  pdfDocType: 'invoice',
	  currentPage: 1,
      perPage: 10,
	  searchQuery: '',
	  expandedDescriptions: {},
	}
},
watch: {
  selected() {
    this.currentPage = 1;
  },
  searchQuery() {
    this.currentPage = 1;
  }
},
methods:{
	getItemDescription(item) {
		if (item.product && item.product.productName) {
			return item.product.productName;
		}
		if (item.quote_id) {
			return item.quote_id.suppliersDesription || item.quote_id.quotesProduct || 'No product info';
		}
		return 'No product info';
	},
	getShortDescription(item) {
		const description = this.getItemDescription(item);
		const words = description.split(' ');
		if (words.length > 10) {
			return words.slice(0, 10).join(' ') + '...';
		}
		return description;
	},
	toggleDescription(itemId) {
		this.$set(this.expandedDescriptions, itemId, !this.expandedDescriptions[itemId]);
	},
	isExpanded(itemId) {
		return !!this.expandedDescriptions[itemId];
	},
	isLongDescription(item) {
		const description = this.getItemDescription(item);
		const words = description.split(' ');
		return words.length > 10;
	},
	nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
	getDesc(items){
		let desc = '';
		items.forEach(element => {
			if (element.product) {
				desc = desc+' '+element.product.productName+','+element.product.productMktDesc

			}
			else{
				desc = desc+' '+element.quote_id.quotesProduct+','+element.quote_id.suppliersDesription
			}
		});
		return desc;
	},
	generatePdf(job){
		const url = this.$store.state.URL+'/generate-pdf/'+job;
		window.open(url, '_blank');
    },
	getPaymentMessage(createdAt, totalDays) {
  if (!createdAt) return '';

  const created = new Date(createdAt);
  const endDate = new Date(created.getTime() + totalDays * 24 * 60 * 60 * 1000);
  const today = new Date();

  const diffTime = endDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) {
    return 'Payment overdue';
  }

  return  'Payment transfers can take 3-5 Working Days';
//   return `Payment can take ${diffDays} Working Day${diffDays > 1 ? 's' : ''}`;
},

getTotalPrice(sellingProductPrice, vat, discountPCP, discountPromoCode, spendDiscountAm){
	return this.$calculateItemTotal(sellingProductPrice, [discountPromoCode, discountPCP, spendDiscountAm], vat);
},
customergeneratePdf(order, docType = 'invoice') {
  this.selectedOrder = order;
  this.pdfDocType = docType;
  this.invoiceName = (docType === 'credit' ? 'Credit-Invoice -' : 'Invoice -') + order.invoiceNumber;
  setTimeout(() => {
    this.$refs.html2Pdf.generatePdf(); // CORRECT METHOD
  }, 2000);
},
hasCompletedAndShipped(activities) {
  if (!Array.isArray(activities)) return false;
  return activities.some(a =>
    a?.title === 'Order Completed & Shipped' ||
    a?.title === 'Order Completed and Shipped'
  );
},
orderHadInvoice(job) {
  return job.paymentMethod === 'Card' || this.hasCompletedAndShipped(this.orderActivs ? this.orderActivs[job.orderNumber] : []);
},
	getQty(items){
		let desc = 0;
		items.forEach(element => {
			desc+=element.quantity.quantity
		});
		return desc;
	},
	formatDate(date) {
    return moment(date).format('YYYY-MM-DD'); // or 'DD-MM-YYYY' if preferred
  },
  async payNow(order) {
	
	const sellingProductPrice = order.items[0]?.quantity?.sellingProductPrice || 0;
	const discountPromoCodeAm = order.items[0]?.discountPromoCodeAm || 0;
	const discountPCPAm = order.items[0]?.discountPCPAm || 0;
	const spendDiscountAm = order.items[0]?.spendDiscountAm || 0;
	const vat = order.items[0]?.vat || 0;

	const totalPrice = this.$calculateItemTotal(sellingProductPrice, [discountPromoCodeAm, discountPCPAm, spendDiscountAm], vat);
	order.items[0].totalPrice = totalPrice;
	const sessionRes = await fetch(this.$store.state.URL + '/api/create-checkout-session', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			order,
			orderId: order._id,
			invoiceNumber:order.invoiceNumber,
			paymentMethod: order.paymentMethod,
			userId: order.user._id,
			paidBy: "Customer"
		})
	});

	const sessionData = await sessionRes.json();

	if (sessionData.id) {
		const stripe = await loadStripe('pk_test_TbhfuPZfID2e9clbH8d43LgD00XEDiNiqn');
		await stripe.redirectToCheckout({ sessionId: sessionData.id });
	} else {
		alert('Stripe session creation failed');
	}
},

},
computed:{
	...mapState(['userOrders','user','orderActivs']),
	usOrders(){
		let ps = [];
		this.userOrders.forEach(element => {
			if(element.items[0] !== null)
			{
				ps.push(element)
			}
		});
		return ps;
	},
	filteredOrders() {
    let orders = this.usOrders;

    // Filter by status
    if (this.selected === 'Paid') {
        orders = orders.filter(order =>
            order.paymentStatus === 'Invoice Paid (Paid at Checkout)' ||
            order.paymentStatus === 'Invoice Paid (Account)'
        );
    } else if (this.selected === 'Unpaid') {
        orders = orders.filter(order =>
            order.paymentStatus === 'Awaiting Payment'
        );
    }

    // Filter by search query
    if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        orders = orders.filter(order => {
            const invoiceNumber = order.invoiceNumber ? String(order.invoiceNumber).toLowerCase() : '';
            const orderNumber = order.orderNumber ? String(order.orderNumber).toLowerCase() : '';
            
            const items = order.items || [];
            const productNameMatch = items.some(item =>
                (item.product && item.product.productName && item.product.productName.toLowerCase().includes(query)) ||
                (item.quote_id && item.quote_id.quotesProduct && item.quote_id.quotesProduct.toLowerCase().includes(query))
            );

            return invoiceNumber.includes(query) || orderNumber.includes(query) || productNameMatch;
        });
    }

    return orders;
},
	totalPages() {
      return Math.ceil(this.filteredOrders.length / this.perPage);
    },
    paginatedOrders() {
      if(this.filteredOrders.length <=0) return []
	  const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredOrders.slice(start, end);
    }

},
	mounted(){
		this.$store.dispatch("getUser")
	}
}
</script>

<style scoped>
.search-input {
  display: inline-block;
  /* width: auto; */
  vertical-align: middle;
  margin-right: 15px;
}
.invoice-table tr{ border: 1px solid lightgrey;}
.invoice-table th{
	font-weight:800;
	padding:8px;
}
.invoice-table td{
	padding:8px;
}
.invoice-table img { cursor: pointer;padding:2px;}
.invoice-table img:hover { border:1px solid red;}
.paynow-btn {
	margin-left: 5px;
}
.search-btns .btn:not(:first-child) {
  margin-left:  5px;
}

.search-btns {
    margin: 5px 0px;
}

.search-btns .btn-primary
 {
  border: none !important;
  box-shadow: none !important;
  text-transform: uppercase;
}
button.btn.ml-2.btn-secondary {
    background: #d3d3d3;
    text-transform: uppercase;
}

th {
    font-weight: 600 !important;
}
button.btn.ml-2.btn-secondary {
    background: #d3d3d3;
    text-transform: uppercase;
}

@media(min-width:993px){
	.invoice-table td{
		white-space: nowrap;
	}
}

@media (max-width: 768px){
	.account-content.parten-bg{
		padding: 0;
	}
	.search-btns b-col .btn.btn-primary{
		margin-top: 0px;
	}
	.row.db-content{
		overflow: auto;
		text-wrap: nowrap;
	}    
	.row.db-content {
        overflow: auto;
        text-wrap: nowrap;
    }
}
@media(max-width: 992px){
	.table > thead > tr > th {
		vertical-align: text-top;
	}
	tr td, tr th,tr td div, tr th div {
		max-width: 213px;
		text-wrap: auto;
	}

	.paynow-btn[data-v-06565bc0] {
		margin-top: 10px;
		margin-left: 0;
	}
}
span{
	color:#000;
}
.link{
  color: #000;
}
@media(max-width:768px){
	    .user-dashboard-menuWrap .c-icon {
        margin-left: 28%;
        margin-top: 11%;
    }
	
}

@media(max-width:550px){
	    .user-dashboard-menuWrap .c-icon {
        margin-left: 33%;
        margin-top: 16%;
    }
}
.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
 /* margin-top: 20px; */
  margin: 20px 0;
}

.pagination-controls button {
  margin: 0 10px;
}

.page-info {
  margin: 0 10px;
}
</style>